// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2688":"52f1b461","9292":"30fb37d3"}[chunkId] + ".chunk.css";
};